module.exports = __webpack_public_path__ + "media/images/lps-life_event_pc-02c1aee1.png";